import { useEffect, useState } from "react";

export type AirportTimezone = {
  code: string;
  timezone: string;
};

let airportTimezonesCache: AirportTimezone[] | null = null;
let airportTimezonesPromise: Promise<AirportTimezone[]> | null = null;

export function loadAirportTimezones() {
  if (airportTimezonesCache) {
    return Promise.resolve(airportTimezonesCache);
  }

  if (!airportTimezonesPromise) {
    airportTimezonesPromise = import("./airport-timezones").then((module) => {
      airportTimezonesCache = module.AirportTimezones;
      return airportTimezonesCache;
    });
  }

  return airportTimezonesPromise;
}

export function useAirportTimezones() {
  const [airportTimezones, setAirportTimezones] = useState<AirportTimezone[]>(
    []
  );

  useEffect(() => {
    void loadAirportTimezones().then(setAirportTimezones);
  }, []);

  return airportTimezones;
}
